'use client'
import { Image } from '@/components'
import { BO_CONG_THUONG, INTERNAL_DATA, SOCIAL_LINKS } from '@/config/global-config'
import { URL_GOOGLE_MAP } from '@/constants/info'
import { URL_IMG } from '@/constants/ui'
import { useAsideCategories } from '@/features/products/hooks/use-aside-aggregations'
import Link from '@/features/ref/components/Link'
import EmailIcon from '@mui/icons-material/Email'
import FacebookIcon from '@mui/icons-material/Facebook'
import LocationPinIcon from '@mui/icons-material/LocationPin'
import { Box, Grid, Stack, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import NextImage from 'next/image'
const TEMP_CATEGORIES = [
  {
    title: (t: (key: string, data?: Record<string, string>) => string) => t('Về MONA', { name: 'HYDRA' }),
    href: '/about',
  },
  {
    title: (t: (key: string) => string) => t('CÂU CHUYỆN SẢN PHẨM'),
    href: '/about',
  },
  // {
  //   title: (t: (key: string) => string) => 'STYLING',
  //   href: '/contact',
  // },
  {
    title: (t: (key: string) => string) => t('Blog'),
    href: '/blog',
  },
  {
    title: (t: (key: string) => string) => t('Liên hệ'),
    href: '/contact',
  },
]
const MAX_ITEM = 2
const GRID_TEMPLATE = { xs: 6, md: 2.2 }
const GRID_TEMPLATE_LARGE = { xs: 12, md: 4.6 }
const GRID_TEMPLATE_MIXED = { xs: 12, md: 4.4 }
export const RightSide = () => {
  const { data: categories } = useAsideCategories()
  const t = useTranslations()

  const getListCategories = () => {
    if (!categories?.items) return []
    if (categories?.items?.length > MAX_ITEM) {
      return [categories.items.slice(0, MAX_ITEM), categories.items.slice(MAX_ITEM)]
    }
    return [categories?.items]
  }
  const listCategories = getListCategories()
  const LIST_M_MEMBER = (t: any) => [
    { title: t('Footer.member.account'), link: '/accounts' },
    { title: t('Footer.member.register'), link: '/register' },
    // { title: t('Footer.member.benefits'), link: '/help/uu-dai-khuyen-mai' },
  ]

  const LIST_POLICY = (t: any) => [
    { title: t('Footer.policy.privacy'), link: '/help/chinh-sach-bao-mat-thong-tin' },
    { title: t('Footer.policy.guide'), link: '/help/huong-dan-dat-hang' },
    { title: t('Footer.policy.payment'), link: '/help/mua-hang-va-thanh-toan' },
    { title: t('Footer.policy.responsibility'), link: '/help/phan-dinh-trach-nhiem-cac-ben' },
    { title: t('Footer.policy.terms'), link: '/help/dieu-khoan-su-dung-website/' },
    { title: t('Footer.policy.shipping'), link: '/help/chinh-sach-giao-hang' },
  ]
  const LIST_BOTTOM = (t: any) => [
    { title: t('Footer.bottom.size-guide'), link: '/help/mua-hang-va-thanh-toan' },
    { title: t('Footer.bottom.shopping-guide'), link: '/help/mua-hang-va-thanh-toan' },
  ]
  return (
    <Stack
      sx={{
        maxWidth: '850px',
        ml: 'auto',
      }}
      spacing={{ xs: 2, md: 4 }}
    >
      {/* <Stack direction={'row'} gap={{ xs: 1, md: 4 }} flexWrap={"wrap"}>
        {TEMP_CATEGORIES.map((item, index) => (
          <Link key={item.href+index.toString()} style={{ display: 'inline-block' }} href={item.href}>
            <Typography
              sx={{
                fontSize: { xs: '0.8rem', md: '1rem' },
                color: 'primary.main',
                fontWeight: 600,
                textTransform: 'uppercase',
                borderBottom: '1px solid transparent',
                transition: 'all 0.2s ease',
                ":hover": { borderBottomColor: 'primary.main' },
                whiteSpace: 'nowrap'
              }}
            >
              {item.title(t)}
            </Typography>
          </Link>
        ))}
      </Stack>
      <Divider sx={{ width: '100%', height: '1px', bg: '#BBBBBA' }} /> */}
      <Grid
        container
        spacing={1}
        rowSpacing={{
          xs: 2,
          md: 4,
        }}
        columns={12}
        sx={{ color: 'primary.main' }}
      >
        <Grid
          size={{
            xs: 12,
            md: 4.1,
          }}
          sx={{ position: 'relative', zIndex: 1, color: 'inherit' }}
        >
          <Stack direction={'row'} alignItems={'center'} spacing={'4px'} mb={1}>
            <Box sx={{ display: 'inline' }}>
              <NextImage width={16} height={16} src={URL_IMG + 'favicon-black.svg'} alt="Favicon" />
            </Box>
            <Typography sx={{ color: 'inherit' }}>-</Typography>
            <Typography
              variant="body2"
              sx={{ color: 'inherit' }}
              fontWeight="600"
              mb={2}
              textTransform="uppercase"
            >
              {t('Footer.member.title')}
            </Typography>
          </Stack>
          <Stack spacing={1}>
            {LIST_M_MEMBER(t).map((item, index) => (
              <RenderCommonTitle link={item?.link} key={index} title={item.title} />
            ))}
          </Stack>
        </Grid>
        {/* <Grid size={GRID_TEMPLATE} sx={{ position: 'relative', zIndex: 1, color: 'inherit' }}>
          <Typography
            variant="body2"
            sx={{ color: 'inherit' }}
            fontWeight="600"
            mb={2}
            textTransform="uppercase"
          >
            {t('Footer.bottom.title')}
          </Typography>
          <Stack spacing={1}>
            {LIST_BOTTOM(t).map((item, index) => (
              <RenderCommonTitle link={item?.link} key={index} title={item.title} />
            ))}
          </Stack>
        </Grid> */}
        {/* <Grid size={GRID_TEMPLATE_LARGE}>
          <Typography variant="body2" fontWeight="600" mb={2} textTransform="uppercase">
            {t('Header.product-category-label')}
          </Typography>

          <Grid container spacing={{ xs: 1, md: 2 }}>
            {listCategories?.map((group, groupIndex) => (
              <Grid
                key={groupIndex}
                size={{
                  xs: listCategories?.length > 1 ? 6 : 12,
                }}
              >
                <Stack spacing={1}>
                  {group?.map((item, index) => (
                    <RenderCommonTitle
                      // link={`/products/${item?.url_key}`}
                      link={`/products`}
                      key={index.toString() + groupIndex.toString()}
                      title={item.name}
                    />
                  ))}
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Grid> */}
        <Grid
          spacing={2}
          sx={{ color: 'primary.main' }}
          size={{
            xs: 12,
            md: 7.9,
          }}
        >
          <Typography
            variant="body2"
            sx={{ color: 'inherit' }}
            fontWeight="600"
            mb={2}
            textTransform="uppercase"
          >
            {t('Footer.policy.title')}
          </Typography>
          <Grid container spacing={1}>
            {LIST_POLICY(t).map((item, index) => (
              <Grid
                size={{
                  xs: 12,
                  md: 6,
                }}
                key={index}
              >
                <RenderCommonTitle link={item?.link} key={`${item.link}-${index}`} title={item?.title} />
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 4.1,
          }}
        >
          <Typography variant="body2" fontWeight="600" mb={2} textTransform="uppercase">
            {t('Liên hệ')}
          </Typography>
          <Stack spacing={1}>
            <Stack direction="row" spacing={1} alignItems="start">
              <EmailIcon fontSize="small" />
              <RenderCommonTitle link={`mailto:${INTERNAL_DATA?.email}`} title={INTERNAL_DATA?.email} />
            </Stack>
            <Stack direction="row" spacing={1} alignItems="start">
              <LocationPinIcon fontSize="small" />
              <RenderCommonTitle
                target="_blank"
                link={`${INTERNAL_DATA.address_link}`}
                title={INTERNAL_DATA.address}
                rel="noopener noreferrer nofollow"
              />
            </Stack>
            <Stack direction="row" spacing={1} alignItems="start">
              <FacebookIcon fontSize="small" />
              <RenderCommonTitle
                target="_blank"
                link={SOCIAL_LINKS.facebook}
                title={'FACEBOOK PAGE'}
                rel="noopener noreferrer nofollow"
              />
            </Stack>
            <Link href={BO_CONG_THUONG.link} target="_blank" rel="noopener noreferrer nofollow">
              <Image src={BO_CONG_THUONG.image} alt="Bộ công thương" sx={{ width: '150px' }} />
            </Link>
            {/* <Link href={`tel:${INTERNAL_DATA?.hotline}`}>
              <Typography
                sx={{
                  color: 'inherit',
                  fontSize: { xs: '1.5rem', xl: '2.5rem' },
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  lineHeight: '1',
                }}
              >
                {INTERNAL_DATA?.hotline}
              </Typography>
            </Link> */}
          </Stack>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 7.9,
          }}
        >
          <iframe
            src={URL_GOOGLE_MAP}
            width="100%"
            height={300}
            title="location-map"
            loading="lazy"
            style={{ borderRadius: '8px' }}
          ></iframe>
        </Grid>
      </Grid>
    </Stack>
  )
}
const RenderCommonTitle = ({
  title,
  link,
  target = '_blank',
  rel,
}: {
  title: string
  link: string
  target?: string
  rel?: string
}) => {
  return (
    <Link href={link} target={target} rel={rel}>
      <Typography
        variant="body2"
        sx={{
          color: 'inherit',
          position: 'relative',
          width: 'fit-content',
          fontWeight: 300,
          paddingBottom: '4px',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            right: 0,
            width: 0,
            height: '1px',
            backgroundColor: 'primary.main',
            transition: 'width 0.3s ease',
          },
          ':hover::after': {
            width: '100%',
            left: '0',
          },
        }}
      >
        {title}
      </Typography>
    </Link>
  )
}
